/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'
// import Logo from 'components/ui/Logo'

import './style'
import './media'

/*Images*/

const ListPhotos = props => (
    <div className="list-photos">
        {props.children}
    </div>
)

export default ListPhotos